var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"type":"error"}},[_vm._v(_vm._s(_vm.$t('message.error.desc.authErrorDesc'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }